

/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as InteractionTypes from '../interactions/types'
import * as UtilityTypes from '../utilities/types'

import * as TemplateContextTypes from "./types"

export type InternalGetTemplateContextKey = ['companies',string | undefined,'communicator','subjects',string | undefined,'template-context',unknown];

export type InternalGetTemplateContextResponse = UtilityTypes.SingletonResponse & {
    data?: TemplateContextTypes.TemplateContext;
};

export type InternalGetTemplateContextVariables = {
    companyId: string | undefined;
    subject: string | undefined;
    body?: void;
    query?: {
        channel: InteractionTypes.InteractionChannel;
    };
}

export const internalGetTemplateContext = makeData<
  InternalGetTemplateContextResponse,
  InternalGetTemplateContextKey,
  InternalGetTemplateContextVariables
>({
  method: 'get',
  name: 'internalGetTemplateContext',
  summary: "Get template context",
  path: '/companies/{companyId}/communicator/subjects/{subject}/template-context',
  queryKey: ({query, companyId,
subject,}) => ['companies',companyId,'communicator','subjects',subject,'template-context', query],
})
